import { Controller } from "@hotwired/stimulus";

// Toggles a call's name between a display label (with a pencil) and an inline
// edit form. The form submits normally (PATCH) — this controller only handles
// showing/hiding the editor and Escape-to-cancel.
export default class extends Controller {
  static targets = ["display", "form", "input"];

  edit(event) {
    event.preventDefault();
    event.stopPropagation();
    this.displayTarget.classList.add("d-none");
    this.formTarget.classList.remove("d-none");
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  cancel(event) {
    if (event) event.preventDefault();
    this.formTarget.classList.add("d-none");
    this.displayTarget.classList.remove("d-none");
  }

  onKeydown(event) {
    if (event.key === "Escape") this.cancel(event);
  }
}
